import React from 'react'
import Tippy from '@tippyjs/react'

import BikeEvents from '../sections/bikeProfieEvents/BikeProfileMotorcycleEvents'
import './ListingMapMarker.css'
const ListingMapMarker = (props) => {
  return (
    <Tippy
      trigger="click"
      sticky={true}
      arrow={true}
      arrowType={'sharp'}
      hideOnClick={true}
      className="map-pop-over-content"
      theme="light-border"
      interactive={true}
      boundary={() => document.getElementById('search-right-map')}
      content={
        <div className="event-map-marker-info">
          <BikeEvents
            isMobile={props.isMobile}
            event={props.event}
            latitude={props.lat}
            longitude={props.lng}
            location={props.location}
          />
        </div>
      }
      appendTo={() => document.getElementById('search-right-map')}
    >
      <button className="map-trigger-button p-1">
        <img className="event-map-marker" src={props.event.image_url} />
      </button>
    </Tippy>
  )
}

export default ListingMapMarker